// Libs
import _omit from 'lodash/omit'

// Local
function composer () {
  return function ({
    type: typeCreator,
    ignoreStore = true,
  }) {
    const type = typeCreator()

    return function (payload = {}, { meta = {}, error = false } = {}) {
      const requestId = payload.requestId || meta.requestId || null

      return {
        type,
        payload: _omit(payload, requestId),
        meta: {
          requestId,
          ignoreStore,
          ...meta,
        },
        error,
      }
    }
  }
}

export default function (state) {
  return function ({actionTypes}) {
    const actionCreators = {}
    const compose = composer()

    actionCreators['receive'] = compose({
      type: actionTypes.receive,
      ignoreStore: false,
    })

    const permissions = state.permissions()

    if (permissions.create) {
      actionCreators['create'] = compose({type: actionTypes.create})
      actionCreators['creating'] = compose({type: actionTypes.creating})
      actionCreators['created'] = compose({type: actionTypes.created})
      actionCreators['failCreate'] = compose({type: actionTypes.failCreate})
    }

    if (permissions.read) {
      actionCreators['fetch'] = compose({type: actionTypes.fetch})
      actionCreators['fetching'] = compose({type: actionTypes.fetching})
      actionCreators['fetched'] = compose({type: actionTypes.fetched})
      actionCreators['failFetch'] = compose({type: actionTypes.failFetch})
    }

    if (permissions.update) {
      actionCreators['update'] = compose({type: actionTypes.update})
      actionCreators['updating'] = compose({type: actionTypes.updating})
      actionCreators['updated'] = compose({type: actionTypes.updated})
      actionCreators['failUpdate'] = compose({type: actionTypes.failUpdate})
    }

    if (permissions.delete) {
      actionCreators['delete'] = compose({type: actionTypes.delete})
      actionCreators['deleting'] = compose({type: actionTypes.deleting})
      actionCreators['deleted'] = compose({
        type: actionTypes.deleted,
        ignoreStore: false,
      })
      actionCreators['failDelete'] = compose({type: actionTypes.failDelete})
    }

    return {
      ...actionCreators,
      compose,
    }
  }
}
